import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../store";

export const selectOptimizedContent = (state: RootState) => state.optimizeContent;

export const selectOptimizedArticles = createSelector(selectOptimizedContent, (state) => {
  return state.optimizedArticles;
}
);
